<template>
  <div v-if="taglist.length > 0" class="tags">
    <ul>
      <li
        v-for="(item, index) in taglist"
        :key="index"
        class="tags-li"
        :class="{ active: item.path === $route.fullPath }"
      >
        <router-link :to="item.path" class="tags-li-title">
          {{
            whichLang() === "thai"
              ? item.titleTh
              : whichLang() === "zh"
              ? item.title
              : item.titleEn
          }}
        </router-link>
        <span class="tags-li-icon" @click="closeTags(index)"
          ><i class="el-icon-close"
        /></span>
      </li>
    </ul>
    <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <el-button size="mini" type="primary">
          {{ $t("supplementaryPrompt.LabelOption")
          }}<i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown" size="small">
          <el-dropdown-item command="other">
            {{ $t("openBrandShop.CloseOther") }}
          </el-dropdown-item>
          <el-dropdown-item command="all">
            {{ $t("openBrandShop.CloseAll") }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
// import bus from '../../common/bus.js'
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      taglist: [],
    };
  },
  computed: {
    // ...mapGetters(["taglist"]),
  },
  watch: {
    $route: {
      handler(newValue) {
        this.setTags(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    // ...mapMutations(["SET_taglist"]),
    whichLang() {
      let langNum = "thai";
      localStorage.getItem("lang") === "thai"
        ? (langNum = "thai")
        : localStorage.getItem("lang") === "zh"
        ? (langNum = "zh")
        : (langNum = "en");
      return langNum;
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.taglist.splice(index, 1)[0];
      const item = this.taglist[index]
        ? this.taglist[index]
        : this.taglist[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push("/");
      }
      // this.$store.commit("SET_taglist", this.taglist);
      this.$emit("tagChange", this.taglist);
    },
    // 关闭全部标签
    closeAll() {
      this.taglist = [];
      // this.$store.commit("SET_taglist", this.taglist);
      this.$router.push("/");
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.taglist.filter((item) => {
        return item.path === this.$route.fullPath;
      });
      this.taglist = curItem;
      // this.$store.commit("SET_taglist", this.taglist);
    },
    // 设置标签
    setTags(route) {
      const index = this.taglist.findIndex(
        (item) => item.name === route.matched[1].components.default.name
      );
      if (index === -1) {
        // tab中不存在该路由组件，则直接添加
        if (this.taglist.length >= 8) {
          this.taglist.shift();
        }
        this.taglist.push({
          titleEn: route.meta.titleEn,
          titleTh: route.meta.titleTh,
          title: route.meta.title,
          path: route.fullPath,
          name: route.matched[1].components.default.name, // 组件的默认名称，用于对组件进行缓存
        });
        this.$emit("tagChange", this.taglist);
      } else if (this.taglist[index].path !== route.fullPath) {
        // 如果存在该路由组件，并且参数不一致时，清除老的tab，添加新的tab
        this.taglist.splice(index, 1);
        this.$emit("tagChange", this.taglist);
        var that = this;
        setTimeout(function () {
          that.taglist.push({
            titleEn: route.meta.titleEn,
            titleTh: route.meta.titleTh,
            title: route.meta.title,
            path: route.fullPath,
            name: route.matched[1].components.default.name, // 组件的默认名称，用于对组件进行缓存
          });
          that.$emit("tagChange", that.taglist);
        }, 100);
      }
      // this.$store.commit("SET_taglist", this.taglist);
    },
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    },
  },
};
</script>

<style>
.tags {
  position: relative;
  height: 30px;
  overflow: hidden;
  background: #fff;
  padding-right: 120px;
  box-shadow: 0 5px 10px #ddd;
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.tags-li {
  float: left;
  margin: 3px 5px 2px 3px;
  border-radius: 3px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 23px;
  line-height: 23px;
  border: 1px solid #e9eaec;
  background: #fff;
  padding: 0 5px 0 12px;
  vertical-align: middle;
  color: #666;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}

.tags-li.active {
  color: #fff;
  border: 1px solid #409eff;
  background-color: #409eff;
}

.tags-li-title {
  float: left;
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 5px;
  color: #666;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

.tags-close-box {
  position: absolute;
  right: 0;
  top: 0;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 110px;
  height: 30px;
  background: #fff;
  box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Tags.vue